import { ThemeProvider, theme } from "@primer/react";

import { AuthProvider } from "oidc-react";
import { useEffect, useMemo } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import BaseStyles from "./BaseStyles";
import LoaderPage from "./components/loader-page";
import AuthorizedContent from "./content/AuthorizedContent";
import SigoutContent from "./content/SigoutContent";
import UnAuthorizedContent from "./content/UnAuthorizedContent";
import { CommonProvider } from "./contexts/common";
import { AcceptionFormPage } from "./pages";
import LegalViewPage from "./pages/legal-document/view/LegalViewPage";
import { actions } from "./state/actions/actionsWrapper";
import { localizedResourceAction } from "./state/actions/localized-resource/localizedResourceAction";
import { RootState } from "./state/reducers";
import { eAccountReducerStatus } from "./state/reducers/authReducer";
import deepmerge from "deepmerge";

const customTheme = deepmerge(
  {
    ...theme,
    fontSizes: [
      "11px",
      "13px",
      "16px",
      "20px",
      "24px",
      "32px",
      "40px",
      "48px",
      "56px",
    ],
    radii: ["4px", "6px", "8px"],
  },
  {
    colorSchemes: {
      light: {
        colors: {
          accent: {
            fg: "#0969da",
            emphasis: "#0969da",
          },
          btn: {
            bg: "#fff",
            primary: {
              bg: "#0969da",
              focusBg: "#0969da",
              hoverBg: "#0969da",
              selectedBg: "#0969da",
              disabledBg: "rgba(84, 174, 255, 0.4)",
            },
          },
          primer: {
            border: {
              active: "#0969da",
            },
          },
        },
      },
    },
  },
);
function App() {
  const { user_info, status, isSignOuted } = useSelector(
    (x: RootState) => x.auth,
  );
  const { language } = useSelector((x: RootState) => x.common);
  const { appConfig } = useSelector((x: RootState) => x.appConfig);
  const path = window.location.pathname;

  const regex = /[?&]lan=([^&]+)/;
  const match = window.location.search.match(regex);
  const languageParam = match ? match[1] : "vi";
  // console.log({
  //   path,
  //   languageParam
  // });

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(localizedResourceAction.loadStart(language));
  }, [language]);
  useEffect(() => {
    dispatch(actions.appConfig.loadStart());
  }, []);
  const oidcConfig: any = useMemo(() => {
    if (!appConfig) {
      // debugger
    }
    return {
      onSignIn: (e: any) => {
        // debugger
        console.log({
          onSignIn: e,
        });
      },
      authority: appConfig?.OIDC_AUTHORITY,
      clientId: appConfig?.OIDC_CLIENT_ID,
      redirectUri: appConfig?.OIDC_REDIRECT_URI,
      clientSecret: appConfig?.OIDC_CLIENT_SECRET,
    };
  }, [appConfig]);
  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      dispatch(actions.account.getUserStart());
    }
  }, []);

  if (status === eAccountReducerStatus.is_getting_profile) {
    return <LoaderPage />;
  }
  // if (appConfigStatus === ePageBaseStatus.is_loading) {
  //   return <LoaderPage />
  // }
  // if (path === "/legal") {
  //   return <LegalViewPage />
  // }

  return (
    <Router>
      <ThemeProvider theme={customTheme} colorMode={"light"}>
        <BaseStyles>
          <CommonProvider>
            {path === "/legal" && (
              <LegalViewPage isShowPhoneFrame={false} lan={languageParam} />
            )}
            {path === "/acceptance-form" && <AcceptionFormPage />}
            {path !== "/legal" && path !== "/acceptance-form" && (
              <>
                {isSignOuted === true && (
                  <AuthProvider {...oidcConfig}>
                    <SigoutContent />
                  </AuthProvider>
                )}

                {user_info && <AuthorizedContent />}
                {!user_info && <UnAuthorizedContent />}
              </>
            )}
          </CommonProvider>
        </BaseStyles>
      </ThemeProvider>
    </Router>
  );
}

export default App;
